import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Info = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 22C17.5049 22 22 17.495 22 12C22 6.50495 17.5049 2 12 2C6.49505 2 2 6.49505 2 12C2 17.5049 6.50495 22 12 22Z",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 10.23V16.96",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 8.13C12.5523 8.13 13 7.68229 13 7.13C13 6.57772 12.5523 6.13 12 6.13C11.4477 6.13 11 6.57772 11 7.13C11 7.68229 11.4477 8.13 12 8.13Z",
                fill: "currentColor"
            })
        ]
    });
};
